
export async function setIntervalAndExecute(fn, t) {
  await fn(true);
  return (setInterval(fn, t));
}
